module.exports = __webpack_public_path__ + "img/Aerial02-6K-ExtFn1.111d3cda.gif";